import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// ------------------------------------
// Constants
// ------------------------------------
export const constants = {
  DELETE_ALL_SELECTED_VALUES: createSagaAction('DELETE_ALL_SELECTED_VALUES'),
}

// ------------------------------------
// Action creators
// ------------------------------------
export const actions = {
  deleteAllSelectedValues: (formData, next) => ({
    type: constants.DELETE_ALL_SELECTED_VALUES.ACTION,
    formData,
    next
  }),
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [constants.DELETE_ALL_SELECTED_VALUES.ACTION]: state => {
    return { ...state, error: false, isLoading: true }
  },
  [constants.DELETE_ALL_SELECTED_VALUES.SUCCESS]: (state, action) => {

    return {
      ...state,
      ...action.payload,
      isLoading: false
    }
  },
  [constants.DELETE_ALL_SELECTED_VALUES.FAILED]: (state, action) => {
    return { ...state, error: true, errorMessage: action.errorMessage, isLoading: false }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  error: false,
  errorMessage: '',
  isLoading: false
}

export default createReducer(initialState, (state, action) => {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : { ...state, isLoading: false }
})
